"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _isInvitationSubscribed, _session;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = void 0;
const Service_1 = __importStar(require("../Service"));
const events_1 = require("../../events");
const Notifications_1 = require("../../models/Notifications");
const VoxeetApi_1 = __importDefault(require("../../api/VoxeetApi"));
/**
 * @ignore
 */
var NotificationServiceEvents;
(function (NotificationServiceEvents) {
    NotificationServiceEvents["Invitation"] = "invitation";
    NotificationServiceEvents["ConferenceCreated"] = "conferenceCreated";
    NotificationServiceEvents["ConferenceEnded"] = "conferenceEnded";
    NotificationServiceEvents["ConferenceStatus"] = "conferenceStatus";
    NotificationServiceEvents["ParticipantJoined"] = "participantJoined";
    NotificationServiceEvents["ParticipantLeft"] = "participantLeft";
    NotificationServiceEvents["ActiveParticipants"] = "activeParticipants";
})(NotificationServiceEvents || (NotificationServiceEvents = {}));
/**
 * The NotificationService enables [inviting](#invite) participants to a conference. The service also allows [subscribing](#subscribe) to and [unsubscribing](#unsubscribe) from notifications informing about:
 *
 * - [The number of participants](#activeparticipants) who are present at a conference
 * - [Received conference invitations](#invitation)
 * - [Created conferences](#conferencecreated)
 * - [Ended conferences](#conferenceended)
 * - [Participants joining conferences](#participantjoined)
 * - [Participants leaving conferences](#participantleft)
 *
 * @noInheritDoc
 */
let NotificationService = class NotificationService extends Service_1.default {
    /** @ignore */
    constructor(sdk, session) {
        super(sdk);
        _isInvitationSubscribed.set(this, false);
        _session.set(this, void 0);
        __classPrivateFieldSet(this, _session, session);
    }
    /**
     * Subscribes to the specified notifications.
     * @param subscriptions - An array of the subscribed subscription types.
     */
    subscribe(subscriptions) {
        const inviteSubscription = subscriptions.find((s) => s.type === Notifications_1.SubscriptionType.Invitation);
        if (inviteSubscription) {
            __classPrivateFieldSet(this, _isInvitationSubscribed, true);
        }
        if (!inviteSubscription || subscriptions.length > 1) {
            return VoxeetApi_1.default.subscription.post({
                data: {
                    subscriptions: subscriptions.filter((s) => s.type !== Notifications_1.SubscriptionType.Invitation),
                },
            });
        }
    }
    /**
     * Unsubscribes from the specified notifications.
     * @param subscriptions - An array of the subscribed subscription types.
     */
    unsubscribe(subscriptions) {
        const inviteSubscription = subscriptions.find((s) => s.type === Notifications_1.SubscriptionType.Invitation);
        if (inviteSubscription) {
            __classPrivateFieldSet(this, _isInvitationSubscribed, false);
        }
        if (!inviteSubscription || subscriptions.length > 1) {
            return VoxeetApi_1.default.subscription.delete({
                data: {
                    subscriptions: subscriptions.filter((s) => s.type !== Notifications_1.SubscriptionType.Invitation),
                },
            });
        }
    }
    invite(conference, participants) {
        return __awaiter(this, void 0, void 0, function* () {
            return VoxeetApi_1.default.conferences.invite({
                conferenceId: conference.id,
                data: {
                    externalProfiles: participants.map((p) => ({
                        externalId: p.info ? p.info.externalId : p.externalId,
                        externalName: p.info ? p.info.name : p.name,
                        externalPhotoUrl: p.info ? p.info.avatarUrl : p.avatarUrl,
                        permissions: p.permissions,
                    })),
                },
            });
        });
    }
    onInvitationReceived(e) {
        VoxeetApi_1.default.setConferenceTokens(e.conferenceId, e.conferenceToken);
        this.emit(NotificationServiceEvents.Invitation, e);
    }
    onConferenceStatusNotification(e) {
        this.emit(NotificationServiceEvents.ConferenceStatus, e);
    }
    onConferenceCreatedNotification(e) {
        this.emit(NotificationServiceEvents.ConferenceCreated, e);
    }
    onConferenceEndedNotification(e) {
        this.emit(NotificationServiceEvents.ConferenceEnded, e);
    }
    onParticipantJoinedNotification(e) {
        this.emit(NotificationServiceEvents.ParticipantJoined, e);
    }
    onParticipantLeftNotification(e) {
        this.emit(NotificationServiceEvents.ParticipantLeft, e);
    }
    onActiveParticipants(e) {
        this.emit(NotificationServiceEvents.ActiveParticipants, e);
    }
};
_isInvitationSubscribed = new WeakMap(), _session = new WeakMap();
NotificationService = __decorate([
    Service_1.Subscribe([
        events_1.EventType.InvitationReceived,
        events_1.EventType.ConferenceCreatedNotification,
        events_1.EventType.ConferenceEndedNotification,
        events_1.EventType.ConferenceStatusNotification,
        events_1.EventType.ParticipantJoinedNotification,
        events_1.EventType.ParticipantLeftNotification,
        events_1.EventType.ActiveParticipants,
    ])
], NotificationService);
exports.NotificationService = NotificationService;
